import { createFeatureSelector, createSelector } from '@ngrx/store';
import { activeEvents } from '@shared/utils/event.utils';
import { EVENT_FEATURE_KEY, EventState } from './event.reducer';

export const selectEventState = createFeatureSelector<EventState>(EVENT_FEATURE_KEY);

/**
 * Everything the range fetch returned, cancelled and superseded sedute included.
 * Only for a view that deliberately shows the history — read {@link selectEvents}
 * otherwise.
 */
export const selectAllEvents = createSelector(selectEventState, (state) => state?.data ?? null);

/**
 * The events still in play — the default read, behind every calendar and every
 * dashboard counter.
 *
 * Two kinds have to be dropped explicitly, and neither shows in `status` the way
 * one would expect. A cancelled seduta is a soft delete that leaves `status`
 * untouched (see `isEventDeleted`). A MOVED one leaves a `RESCHEDULED` headstone
 * behind while its replacement lives on: keeping both is why one moved seduta
 * appeared TWICE on the calendar, the old slot still looking booked.
 */
export const selectEvents = createSelector(
  selectAllEvents,
  (events) => (events ? activeEvents(events) : null),
);

/**
 * The top-bar day agenda — its own slot, so opening it doesn't truncate the dashboard's
 * month. Cancelled and superseded sedute are filtered here too.
 */
export const selectAgendaEvents = createSelector(
  selectEventState,
  (state) => (state?.agenda ? activeEvents(state.agenda) : null),
);

export const selectEventsLoading = createSelector(selectEventState, (state) => state?.loading ?? false);
export const selectEventsError = createSelector(selectEventState, (state) => state?.error ?? null);
